import { makeAutoObservable, reaction } from 'mobx'
import { makePersistable } from 'store/persist'
import { tokenManager } from 'api/fetcher'
import { emitter, EventType } from 'infra/events'

export class AuthStore {
  isInitialized: boolean = false
  token: string | null = null

  get isLoggedIn() {
    const token = this.token
    return !!token && token.length > 0
  }

  constructor() {
    makeAutoObservable(this)
    reaction(
      () => this.token,
      (v) => tokenManager.setToken(v),
    )
    // logout when token invalidated
    emitter.addListener(EventType.TOKEN_INVALIDATED, () => this.setToken(null))
    this.initializePersistence()
  }

  private async initializePersistence() {
    try {
      await makePersistable(this, ['token'])
    } catch (error) {
      // A corrupt/unavailable AsyncStorage must not leave the app on InitScreen.
      console.warn('[auth-persistence] Failed to restore session', error)
    } finally {
      tokenManager.setToken(this.token)
      this.setIsInitialized(true)
    }
  }

  setToken(v: string | null) {
    this.token = v
  }

  setIsInitialized(v: boolean) {
    this.isInitialized = v
  }
}

export const authStore = new AuthStore()
